import React, {Component} from 'react';
import { Col, Row, Tabs,Checkbox,Tab,Modal,Button, FormControl} from 'react-bootstrap';
 import moment   from 'moment'
import config from  '../../../config';
import formatNumbers  from 'util/formatNumbers';
import json2csv   from 'json2csv'
 import Select   from 'react-select'
  import {prepareSelectOptionsList,} from 'util/Utils';
 const allReportFieldList = [
     {label: 'Title', value:'ProductName'},
     {label: 'Shopify product link', value:'ShopifyProductLink'},
     {label: 'Current price', value:'Price'},
     {label: 'Status', value:'Status'},
     {label: 'Condition', value:'Condition'},
      {label: 'SKU', value:'SKU'},
     {label: 'Original price', value:'OriginalPrice'},
     {label: 'Location', value:'Markets.0.MarketName'},
     {label: 'Create date', value:'createdAt'},
      {label: 'Available Quantity', value:'ProductVariants.0.Quantity'},
      {label: 'Sold Quantity', value:'SoldQuantity'},
      {label: 'TrackingNumbers', value:'TrackingNumbers'},
      {label: 'Sold Date', value:'SoldDate'},
      {label: 'Payout Amount', value:'PayoutAmount'},
  ]
var reportFieldsForTrackingNumbers =_.reject(allReportFieldList, field=>{
    return _.includes(['TrackingNumbers'],field.value)
}).concat([
    {label: 'Tracking Number', value:'TrackingNumbers.TrackingNumber'},
    {label: '# Disposition', value:'TrackingNumbers.Disposition'},
    {label: '# Invoice Cost', value:'TrackingNumbers.InvoiceCost'},
    {label: '# Item SKU', value:'TrackingNumbers.ProductItemSKU'},
     {label: '# Date Added', value:'TrackingNumberAddedAt'},
])



export default class PartnerProductActionsBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            reducePriceValue:10,
            addNewTagValue:'',
            assignGBGProductValue:'',
            selectedAction:'',
            foundGBGProductsList:[],
            updateProductModalVisible:false,
            showBulkUpdateErrorsModal:false,
            recordsNotUpdated:[],
            pending: false,
            additionalData:{},
             currentBulkUpdateAction:'',
                    reportFields:allReportFieldList,
          };
        this.allSellersOptionsList = prepareSelectOptionsList(this.props.allSellersList.data, {
            label: 'DisplayName',
            value: '_id'
        })
        // this.bulkUpdateActionsMap = {
        //     'reducePrice':{
        //         modalButtonLabel: 'Reduce Price'
        //      },
        //     'addNewTag':{
        //         modalButtonLabel: 'Add New Tag'
        //     }
        // }
    };


    componentWillReceiveProps(nextProps) {


        if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
            this.allSellersOptionsList = prepareSelectOptionsList(nextProps.allSellersList.data, {
                label: 'DisplayName',
                value: '_id'
            })
         }
    }


    bulkUpdateSelectedProducts() {
         var methodData = {
             "endpoint": "/products_update",
            'type':'post',
            messageData: {'#1#': 'Products'},
            messageCode : 'recordsUpdated'
         };
        var self = this;
        self.setState({ currentBulkUpdateAction:'', pending:true, updateProductModalVisible:false})
         this.props.makeRequest({'products':this.props.adminProducts.selectedProducts,
             type:this.state.currentBulkUpdateAction,
             data:{ [this.state.currentBulkUpdateAction+'Value'] : this.state[this.state.currentBulkUpdateAction + 'Value']} }, methodData).then(response => {
            console.log('response.data',response.data );
                 self.props.search({doNotClearSelectedProducts:true});
              if (_.find(response.data, function (productUpdateResult) {
                     return productUpdateResult.error
                 })) {
                 this.showBulkUpdateErrorsModal(response.data);
             }
             self.setState({  pending:false })
        }).catch(error => {
            console.log('error', error );
             self.setState({  pending:false })
         });
    }
    prepareActionData(){
        var actionData = {}
        switch (this.state.selectedAction) {
            case  'UpdateCOGSForSellerProducts':
                if (_.get(this.state, 'selectedSeller.value')){
                    actionData.SellerID = this.state.selectedSeller.value
                }else{
                    actionData.error = {
                        'messageType': 'warning',
                        'messageCode': 'Please, select seller'
                    }
                }
                break;
            default:
                break
        }
        return  actionData
    }
    onSelectTab(event){
        this.setState({displayReportTab:!this.state.displayReportTab})
    }
    displayAdditionalRunActionsInputs(){
        switch (this.state.selectedAction) {
            case  'UpdateCOGSForSellerProducts':
               return <Col xs={12}  className="top10">
                   <Select
                       tabIndex="0"

                       placeholder="Seller"
                       clearable={false}
                       options={this.allSellersOptionsList}
                       onChange={ (option)=>{
                           console.log('option', option  );
                           this.setState({'selectedSeller': option} )}
                       }
                       value={this.state.selectedSeller}
                   />
               </Col>

                break;
            default:
                return null

        }
    }
    showBulkUpdateErrorsModal(productsNotUpdated){
        var recordsNotUpdated = productsNotUpdated.filter(item => {
            return item.error
        });

        this.setState({
            showBulkUpdateErrorsModal: true,
            recordsNotUpdated: recordsNotUpdated,
            updateProductModalVisible:false,
         })
    }
    downloadReportForProducts(){
        var self  = this;
      if (this.state.pending){
        this.props.displayMessage({
          'messageType': 'warning',
          'messageCode': 'Please wait till download is completed'
        });
        return Promise.reject(false)
      }
      this.setState({pending:true})
         var methodData = {
            "endpoint": "/create-report",
            'type':'post',
             'not_display_success_message':true,
             overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
        };
        var params = {'products': this.props.adminProducts.selectedProducts,
            addFields:[ 'SoldQuantity'],
            reportType:'products' }
            if(this.state.groupByTrackingNumbers){
                params.groupByTrackingNumbers = true

            }
        var {queryParams} = this.props.searchBox.getSearchParams();
       params =_.extend(params,_.pick(queryParams, ['fromSoldAt', 'toSoldAt']))
        self.setState({  pending:true })
        this.props.makeRequest(params, methodData).then(res => {
           var fields = _.map(this.state.reportFields, function (field) {
                return _.extend({}, field, {default: ''});
           })

            self.setState({  pending:false })
           var dataToExport  = _.map(res.data, function (product) {
               var customData = {};

               if ( _.find(fields, {value:  'ShopifyProductLink' })){
                   if (product.Status == 'Active' && _.get(product, 'ShopifyProductHandle')) {
                           customData['ShopifyProductLink'] =config.getEnvironment().shopify.productCustomerUrlTemplate.replace("[product_handle]", _.get(product, 'ShopifyProductHandle'))
                   }
                 }

               if ( _.find(fields, {value:  'TrackingNumberAddedAt' })){
                   if (  _.get(product, 'TrackingNumbers.TrackingNumberAddedAt')) {
                       customData['TrackingNumberAddedAt'] =moment(_.get(product, 'TrackingNumbers.TrackingNumberAddedAt')).format('YYYY-MM-DD HH:mm')
                   }
               }
               product.Price=  product.Price.toFixed(2);
               return {...product,
                   createdAt: moment(product.createdAt).format('YYYY-MM-DD HH:mm'),
                   updatedAt: moment(product.updatedAt).format('YYYY-MM-DD HH:mm'),
                   ...customData}
           })
            var csvData = json2csv.parse(dataToExport, {
                fields: fields,
            })

               var filename = "products_report_" +  moment().format("YYYY-MM-DD-HH-mm")+ ".csv";
               var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
               if (navigator.msSaveBlob) { // IE 10+
                   navigator.msSaveBlob(blob, filename);
               } else {
                   var link = document.createElement("a");
                   if (link.download !== undefined) { // feature detection
                       // Browsers that support HTML5 download attribute
                       var url = URL.createObjectURL(blob);
                       link.setAttribute("href", url);
                       link.setAttribute("download", filename);
                       link.style.visibility = 'hidden';
                       document.body.appendChild(link);
                       link.click();
                       document.body.removeChild(link);
                   }
               }

        }).catch(err => {
            self.setState({  pending:false })
            console.log('err', err );
        });
    }










    render() {

        return (
            <div className="action-block">

                <Tabs defaultActiveKey={''}  onSelect={(e)=>{this.onSelectTab(e)}}  id="productsActions" >
                        {/*unmountOnExit - do not render component until the tab is clicked*/}


                    {/*{_.isUndefined(this.props.location.query.PalletID) && _.size(_.intersection(_.get(this.props, 'userReducer.user.Roles', []), ['Ops Manager', 'Product Manager', 'Administrator'])) > 0 &&*/}

                    {/*<Tab eventKey={'update_products'} unmountOnExit={true} title="Change">*/}
                        {/*<Row className="show-grid">*/}
                            {/*<Col md={3} sm={6} xs={9} className="pleft0  top10">*/}
                                {/*<Col xs={12} className="top10">*/}
                                    {/*<FormControl type="text"*/}
                                                 {/*defaultValue={this.state.reducePriceValue}*/}
                                                 {/*onChange={ (event) => this.setState({reducePriceValue: event.target.value})}*/}
                                                 {/*placeholder="Reduce price by"/>*/}
                                {/*</Col>*/}
                                {/*<Col xs={12} className="top10">*/}
                                    {/*<button className="btn btn-primary red border-red" onClick={() => this.setState({*/}
                                        {/*updateProductModalVisible: true,*/}
                                        {/*modalTitleMessage: <span>Price for <span*/}
                                            {/*style={{color: '#ff2926'}}>{this.props.adminProducts.selectedProducts.length}</span> {this.props.adminProducts.selectedProducts.length == 1 ? 'product' : 'products'}*/}
                                            {/*will be reduced by {this.state.reducePriceValue} percent </span>,*/}
                                        {/*currentBulkUpdateAction: 'reducePrice',*/}
                                    {/*})}*/}
                                            {/*disabled={!this.props.adminProducts.selectedProducts.length}*/}
                                            {/*type="button">*/}
                                        {/*Reduce price*/}
                                    {/*</button>*/}
                                {/*</Col>*/}
                            {/*</Col>*/}

                            {/*<Col md={3} sm={6} xs={9} className="pleft0  top10">*/}
                                {/*<Col xs={12} className="top10">*/}
                                    {/*<FormControl type="text"*/}
                                                 {/*defaultValue={this.state.addNewTagValue}*/}
                                                 {/*onChange={ (event) => this.setState({addNewTagValue: event.target.value})}*/}
                                                 {/*placeholder="Tag"/>*/}
                                {/*</Col>*/}
                                {/*<Col xs={12} className="top10">*/}
                                    {/*<button className="btn btn-primary red border-red" onClick={() => this.setState({*/}
                                        {/*updateProductModalVisible: true,*/}
                                        {/*currentBulkUpdateAction: 'addNewTag',*/}
                                        {/*modalTitleMessage: <span>Tag {this.state.addNewTagValue} will be added to <span*/}
                                            {/*style={{color: '#ff2926'}}>{this.props.adminProducts.selectedProducts.length}</span> {this.props.adminProducts.selectedProducts.length == 1 ? 'product' : 'products'}</span>,*/}
                                    {/*})}*/}
                                            {/*disabled={!this.props.adminProducts.selectedProducts.length || !this.state.addNewTagValue}*/}
                                            {/*type="button">*/}
                                        {/*Add tag*/}
                                    {/*</button>*/}
                                {/*</Col>*/}
                            {/*</Col>*/}

                            {/*<Col md={3} sm={6} xs={9} className="pleft0  top10">*/}
                                {/*<Col xs={12} className="top10">*/}
                                    {/*<Select*/}
                                        {/*tabIndex="0"*/}
                                        {/*clearable={true}*/}
                                        {/*placeholder="GBG Product"*/}
                                        {/*options={this.state.foundGBGProductsList}*/}
                                        {/*optionRenderer={this.renderGBGProductOption}*/}
                                        {/*onInputKeyDown={(e) => {*/}
                                            {/*switch (e.keyCode) {*/}

                                                {/*case 13: // ENTER*/}
                                                    {/*e.preventDefault();*/}
                                                    {/*this.searchGBGProducts(e.target.value);*/}
                                                    {/*break;*/}
                                            {/*}*/}


                                        {/*}}*/}
                                        {/*onChange={(option) => {*/}
                                            {/*console.log('option ', option);*/}
                                            {/*this.setState({*/}
                                                {/*assignGBGProductValue: option ? option.value : null,*/}
                                            {/*})*/}
                                        {/*}}*/}
                                        {/*value={this.state.assignGBGProductValue}*/}
                                    {/*/>*/}
                                {/*</Col>*/}
                                {/*<Col xs={12} className="top10">*/}
                                    {/*<button className="btn btn-primary red border-red" onClick={() => {*/}
                                        {/*var selectedGBGProduct = _.find(this.state.foundGBGProductsList, {'_id': this.state.assignGBGProductValue});*/}
                                        {/*if (!selectedGBGProduct) {*/}
                                            {/*return*/}
                                        {/*}*/}
                                        {/*this.setState({*/}
                                            {/*updateProductModalVisible: true,*/}
                                            {/*currentBulkUpdateAction: 'assignGBGProduct',*/}
                                            {/*modalTitleMessage: <span>GBG Product <span*/}
                                                {/*className="green">{_.get(selectedGBGProduct, ['GBGProduct', 'Brand'], '') + ' ' } </span><span*/}
                                                {/*style={{color: 'orange'}}> { _.get(selectedGBGProduct, ['GBGProduct', 'Model'], '')}</span> will be assigned to <span*/}
                                                {/*style={{color: '#ff2926'}}>{this.props.adminProducts.selectedProducts.length}</span> {this.props.adminProducts.selectedProducts.length == 1 ? 'product' : 'products'}</span>,*/}
                                        {/*})*/}

                                    {/*}}*/}
                                            {/*disabled={!this.props.adminProducts.selectedProducts.length || !this.state.assignGBGProductValue}*/}
                                            {/*type="button">*/}
                                        {/*Assign GBG Product*/}
                                    {/*</button>*/}
                                {/*</Col>*/}
                            {/*</Col>*/}


                            {/*<Col md={3} sm={6} xs={9} className="pleft0  top10">*/}
                                {/*<Col xs={12} className="top10">*/}
                                    {/*<Select*/}
                                        {/*tabIndex="0"*/}
                                        {/*clearable={true}*/}
                                        {/*placeholder="Action"*/}
                                        {/*options={actionsList}*/}
                                        {/*onChange={(option) => {*/}
                                            {/*this.setState({*/}
                                                {/*selectedAction: option ? option.value : null,*/}
                                            {/*})*/}
                                        {/*}}*/}
                                        {/*value={this.state.selectedAction}*/}
                                    {/*/>*/}
                                {/*</Col>*/}
                                {/*<Col xs={12} className="top10">*/}
                                    {/*<button className="btn btn-primary red border-red"*/}
                                            {/*onClick={this.triggerSelectedAction.bind(this)}*/}
                                            {/*disabled={!this.state.selectedAction || this.state.pending}*/}
                                            {/*type="button">*/}
                                        {/*Run action*/}
                                    {/*</button>*/}
                                {/*</Col>*/}
                                {/*{this.displayAdditionalRunActionsInputs()}*/}
                            {/*</Col>*/}
                        {/*</Row>*/}


                    {/*</Tab>*/}
                    {/*}*/}
                    <Tab eventKey={'reports'} unmountOnExit={true}  className={this.state.displayReportTab ? '' : 'hidden'}
                         title="Reports">
                        <Row className="show-grid">
                            <Col md={4} xs={6} className="top10">
                                <Select
                                    tabIndex="0"
                                    searchable={true}
                                    multi
                                    selectedOptions
                                    clearable={false}
                                    placeholder="Included fields"
                                    options={allReportFieldList}
                                    onChange={ (selectedOptions) => this.setState({'reportFields': selectedOptions})}
                                    value={this.state.reportFields}
                                />

                                <Checkbox style={{   }}
                                          className="top10  "
                                          onChange={(e) =>{
                                              var dataToUpdate ={groupByTrackingNumbers: !this.state.groupByTrackingNumbers}
                                              if (dataToUpdate.groupByTrackingNumbers){
                                                  dataToUpdate.reportFields =reportFieldsForTrackingNumbers
                                              }else{
                                                  dataToUpdate.reportFields =allReportFieldList
                                              }
                                              this.setState(dataToUpdate)
                                          }}
                                          checked={this.state.groupByTrackingNumbers} inline><span className=" left5">Show tracking numbers in separate rows</span></Checkbox>
                            </Col>


                        </Row>
                        <Row>
                            <Col md={4} xs={6} className="top10">
                                <button className="btn btn-primary"
                                        onClick={()=>{
                                            var dataToUpdate ={reportFields:[...this.state.reportFields]}
                                             if (_.get(this.props.location.query, 'disposition')){
                                                 if (!_.find(this.state.reportFields, {value:'Disposition'})){
                                                     dataToUpdate.reportFields =   _.concat(dataToUpdate.reportFields, [
                                                        {label: 'Disposition', value:'Disposition'},
                                                         {label: 'Invoice cost', value:'InvoiceCost'},
                                                        {label: 'TrackingNumbers', value:'TrackingNumbers'}
                                                        ])
                                                 }
                                            }
                                            this.setState(dataToUpdate,function() {
                                                this.downloadReportForProducts()
                                            })
                                        }}
                                        disabled={this.state.pending}
                                        type="button">
                                    Download report
                                </button>
                            </Col>


                        </Row>

                    </Tab>

                    </Tabs>
                 <Modal  show={this.state.updateProductModalVisible}
                         onHide={(e)=>this.setState({ currentBulkUpdateAction:'', updateProductModalVisible:false})}     >
                    <Modal.Header>
                        <Modal.Title>{this.state.modalTitleMessage}</Modal.Title>
                    </Modal.Header>

                    <Modal.Footer>
                        <Button onClick={(e)=>this.setState({ currentBulkUpdateAction:'', updateProductModalVisible:false})}>Cancel</Button>
                        <Button
                            disabled={this.state.pending}
                            onClick={(e)=>this.bulkUpdateSelectedProducts() }
                                bsStyle="primary">{ _.startCase(this.state.currentBulkUpdateAction)}</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showBulkUpdateErrorsModal}
                       onHide={() => this.setState({
                           showBulkUpdateErrorsModal: false
                       })}>
                    <Modal.Header closeButton>
                        <Modal.Title> {this.state.recordsNotUpdated.length}  {this.state.recordsNotUpdated.length == 1 ? 'product was ' : 'products were'} not updated.</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                                 <Row className="bot20">
                                    <Col md={12} sm={12} xs={12}
                                         style={{textAlign: 'justify'}}>
                                            <div className="bot10">
                                                Please, check email for update error details for the following {this.state.recordsNotUpdated.length == 1 ? 'product' : 'products'}:
                                            </div>
                                            {this.state.recordsNotUpdated.map( (updateProductErrorResult, i) => <div style={{
                                                 fontWeight: '500', marginTop:3,
                                             }} key={'x'+i}>{_.get(updateProductErrorResult, ['data', 'ShopifyProductID'], '') + ' ' + _.get(updateProductErrorResult, ['data', 'ProductName'], '')}</div> )}
                                     </Col>
                                </Row>
                         </div>
                    </Modal.Body>
                    <Modal.Footer>
                             <Row className="left0">
                                <Col md={12} sm={12} xs={12} className="pleft0">
                                    <Button className="pull-right btn right20 btn-default"
                                            type="button"
                                            onClick={() => this.setState({
                                                showBulkUpdateErrorsModal: false
                                            })}>
                                        OK
                                    </Button>
                                </Col>
                            </Row>
                     </Modal.Footer>
                </Modal>
                {this.state.pending &&
                <div className="pending-box"></div>
                }
                </div >
        );

    }
}



